export enum MATERIAL_STATUS_CODE {
    ORDERED = 'ORDERED',
    PICKED = 'PICKED',
    CONSUMED = 'CONSUMED',
    PREPAREDTORETURN = 'PREPAREDTORETURN',
    TOBERETURNED = 'TOBERETURNED',
    RETURNWITHOUTCONSUME = 'RETURNWITHOUTCONSUME',
    RETURNED = 'RETURNED',
    NOTRECEIVED = 'NOTRECEIVED',
    LEFTONNOTIFICATION = 'LEFTONNOTIFICATION',
    NOPHYSICALRETURN = 'NOPHYSICALRETURN',
    REQUESTED = 'REQUESTED',
}

export interface JsonMaterialStatusModel {
    statusCode: MATERIAL_STATUS_CODE;
}

export class MaterialStatusModel {
    public constructor(public statusCode: MATERIAL_STATUS_CODE) {}

    /**
     * Material is "Ordered" or "Not Received"
     *
     * @returns true if the material is ordered or not received
     */
    public get isOrderedOrNotReceived(): boolean {
        return this.statusCode === MATERIAL_STATUS_CODE.ORDERED || this.statusCode === MATERIAL_STATUS_CODE.NOTRECEIVED;
    }

    /**
     * Material is "Ordered" or "Picked"
     *
     * @returns true if the material is ordered or picked
     */
    public get isOrderedOrPicked(): boolean {
        return this.statusCode === MATERIAL_STATUS_CODE.ORDERED || this.isPicked;
    }

    /**
     * Material is "Received" and "Picked"
     *
     * @returns true if the material is received and picked
     */
    public get isReceivedAndPicked(): boolean {
        return !this.isNotReceived && this.isPicked;
    }

    /**
     * Material is "Not Received"
     *
     * @returns true if the material is not received
     */
    public get isNotReceived(): boolean {
        return this.statusCode === MATERIAL_STATUS_CODE.NOTRECEIVED;
    }

    /**
     * Material is "Picked"
     *
     * @returns true if the material is picked
     */
    public get isPicked(): boolean {
        return (
            this.statusCode === MATERIAL_STATUS_CODE.PICKED ||
            this.statusCode === MATERIAL_STATUS_CODE.PREPAREDTORETURN ||
            this.statusCode === MATERIAL_STATUS_CODE.RETURNED
        );
    }

    public get isReturn(): boolean {
        return (
            this.statusCode === MATERIAL_STATUS_CODE.PREPAREDTORETURN ||
            this.statusCode === MATERIAL_STATUS_CODE.TOBERETURNED
        );
    }

    public get isNoPhysicalReturn(): boolean {
        return this.statusCode === MATERIAL_STATUS_CODE.NOPHYSICALRETURN;
    }

    public get isReturned(): boolean {
        return this.statusCode === MATERIAL_STATUS_CODE.RETURNED;
    }

    public get isRequested(): boolean {
        return this.statusCode === MATERIAL_STATUS_CODE.REQUESTED;
    }

    public get isReturnedOrRequested(): boolean {
        return this.isReturned || this.isRequested;
    }
}

export class MaterialStatusModelFromJson extends MaterialStatusModel {
    public constructor(data: JsonMaterialStatusModel) {
        super(data.statusCode);
    }
}
